import { publicClientApp } from 'configs';
import { usePersistentService } from 'services';

export const logout = () => {
  publicClientApp.logoutRedirect();
  usePersistentService.getState().reset();
};
